const CmsType = {
    Top_Ribbon: 'top_ribbon',
    Home_Banner: 'home_banner',
    Category_Carousel: 'category_carousel',
    Category_Banner: 'category_banner',
    Shop_By_Category: 'shop_by_category',
    Products_Carousel: "products_carousel",
    Brochure: "brochure",
    Bottom_Banner: "bottom_banner",
    Brand: "brand",
    MultiBuy: 'multibuy',
    Sponsor: 'sponsor',
    Presell_Section: 'presell_section',
    TradeShow_Section: 'tradeshow_section',
    Mega_Menu_Banner: 'mega_menu_banner',
    Splash_Screen: 'splash_screen',
}
const CmsTypeStr = {
    [CmsType.Top_Ribbon]: 'Top Ribbon',
    [CmsType.Home_Banner]: 'Home Banner',
    [CmsType.Category_Carousel]: 'Category Carousel',
    [CmsType.Category_Banner]: 'Category Banner',
    [CmsType.Shop_By_Category]: 'Shop by Category',
    [CmsType.Products_Carousel]: "Products Carousel",
    [CmsType.Brochure]: "Brochure",
    [CmsType.Bottom_Banner]: "Bottom Banner",
    [CmsType.Brand]: "Brand",
    [CmsType.MultiBuy]: 'MultiBuy',
    [CmsType.Sponsor]: 'Sponsor',
    [CmsType.Presell_Section]: 'Presell Section',
    [CmsType.TradeShow_Section]: 'TradeShow',
    [CmsType.Mega_Menu_Banner]: 'Mega Menu Banner',
    [CmsType.Splash_Screen]: 'Splash Screen',
}

const LocalStorageKey = {
    AUTH_TOKEN: "united_order_cms_auth_token",
    LAST_TOKEN_UPDATED: "united_order_cms_last_token_updated",
    AUTH_USER: "united_order_cms_auth_user",
    CURRENT_MENU: 'current_menu',
}

const PriceList = [
    { id: '01', label: '01 - Testing' },
    { id: '05', label: '05 - Q5' },
    { id: '07', label: '07 - TradeDay' },
    { id: '08', label: '08 - DTElite' },
    { id: '09', label: '09 - TradeShow' },
    { id: '10', label: '10 - DT' },
    { id: '11', label: '11 - DTClub' },
    { id: '12', label: '12 - USave' },
    { id: '13', label: '13 - Digital' },
    { id: '20', label: '20 - 3WS-Col' },
    { id: '21', label: '21 - 1WS-Col' },
    { id: '22', label: '22 - WES-Col' },
    { id: '23', label: '23 - 1DS-Col' },
    { id: '25', label: '25 - 3WS' },
    { id: '26', label: '26 - 1WS' },
    { id: '27', label: '27 - WES' },
    { id: '28', label: '28 - 1DS' },
    { id: '999', label: '999 - Std' },
]

const ManagerRole = {
    SuperAdmin: 'superadmin',
    CmsAdmin: 'cms_admin',
    CmsUser: 'cms_user',
}
const ManagerRoleOptions = [
    { value: ManagerRole.SuperAdmin, label: 'Super Admin' },
    { value: ManagerRole.CmsAdmin, label: 'CMS Admin' },
    { value: ManagerRole.CmsUser, label: 'CMS User' },
]

const WeekDays = [
    { id: 'mo', label: 'Monday' },
    { id: 'tu', label: 'Tuesday' },
    { id: 'we', label: 'Wednesday' },
    { id: 'th', label: 'Thirsday' },
    { id: 'fr', label: 'Friday' },
    { id: 'sa', label: 'Saturday' },
    { id: 'su', label: 'Sunday' }
];

const ManagerPermission = {
    TopRibbon: 'top_ribbon',
    HomeBanner: 'home_banner',
    ProductsCarousel: 'products_carousel',
    BottomBanner: 'bottom_banner',
    Brand: 'brand',
    Brochure: 'brochure',
    UserManagement: 'user_management',
    SiteConfig: 'site_config',
    SponsorManagement: 'sponsor_management',
    MultiBuy: 'multibuy',
    Branch: 'branch',
    Organization: 'organization',
    Category: 'category',
    CategoryBanner: 'category_banner',
    CategoryCarousel: 'category_carousel',
    ShopByCategory: 'shop_by_category',
    Template: 'template',
    PresellSection: 'presell_section',
    TradeShowSection: 'tradeshow_section',
    MegaMenuBanner: 'mega_menu_banner',
}

module.exports = {
    LocalStorageKey,
    CmsType,
    CmsTypeStr,
    PriceList,
    ManagerRoleOptions,
    ManagerRole,
    WeekDays,
    ManagerPermission,
}